
export const formatSpaceUnit = (measurement) => {
  const defaultMeasurement = 'm2'
  return measurement || defaultMeasurement
}
